import Skeleton from 'react-loading-skeleton';
import Markdown from 'components/Shared/Markdown';
import PatientManagerCard from './PatientManagerCard';
import styles from './PatientManagerComment.module.scss';

type Props = {
  comment?: string;
  isMarkdown?: boolean;
  managerId?: string;
  skeleton?: boolean;
};

const PatientManagerComment = ({
  comment,
  isMarkdown,
  managerId,
  skeleton,
}: Props): JSX.Element | null => {
  if (skeleton) {
    return (
      <div className="mb-6">
        <Skeleton className="mb-2" height={75} count={2} />
      </div>
    );
  }

  if (!comment) {
    return null;
  }

  return (
    <div className={styles.container}>
      {isMarkdown ? (
        <Markdown className={styles.comment}>{comment}</Markdown>
      ) : (
        <p className={styles.comment}>{comment || ''}</p>
      )}
      <div className={styles.commentArrow} />
      <PatientManagerCard
        className={styles.managerCard}
        managerId={managerId}
      />
    </div>
  );
};

export default PatientManagerComment;
